import { render, staticRenderFns } from "./ExtendPlan.vue?vue&type=template&id=a196049c&"
import script from "./ExtendPlan.vue?vue&type=script&lang=js&"
export * from "./ExtendPlan.vue?vue&type=script&lang=js&"
import style0 from "./ExtendPlan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports